import _defineProperty from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _get from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _wrapNativeSuper from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _objectSpread from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _assertThisInitialized from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _toConsumableArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isLocalRef, pathToPointer, stringify, extractSourceFromRef, extractPointerFromRef, resolveInlineRef } from '@stoplight/json';
import { EventEmitter } from '@stoplight/lifecycle';
import createMagicError from 'magic-error';
var SEED = BigInt(0);

var BaseNode = /*#__PURE__*/function () {
  function BaseNode(fragment) {
    _classCallCheck(this, BaseNode);

    this.fragment = fragment;
    this.parent = null;
    this.id = String(SEED++);
    this.subpath = [];
  }

  _createClass(BaseNode, [{
    key: "path",
    get: function get() {
      return this.parent === null ? this.subpath : [].concat(_toConsumableArray(this.parent.path), _toConsumableArray(this.subpath));
    }
  }, {
    key: "depth",
    get: function get() {
      return this.parent === null ? 0 : this.parent.depth + 1;
    }
  }, {
    key: "parentChildren",
    get: function get() {
      var _a, _b;

      return (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    }
  }, {
    key: "pos",
    get: function get() {
      return Math.max(0, this.parentChildren.indexOf(this));
    }
  }, {
    key: "isFirst",
    get: function get() {
      return this.pos === 0;
    }
  }, {
    key: "isLast",
    get: function get() {
      return this.pos === this.parentChildren.length - 1;
    }
  }]);

  return BaseNode;
}();

var MirroredReferenceNode = /*#__PURE__*/function (_BaseNode) {
  _inherits(MirroredReferenceNode, _BaseNode);

  function MirroredReferenceNode(mirroredNode) {
    var _this;

    _classCallCheck(this, MirroredReferenceNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MirroredReferenceNode).call(this, mirroredNode.fragment));
    _this.mirroredNode = mirroredNode;
    return _this;
  }

  _createClass(MirroredReferenceNode, [{
    key: "error",
    get: function get() {
      return this.mirroredNode.error;
    }
  }, {
    key: "value",
    get: function get() {
      return this.mirroredNode.value;
    }
  }, {
    key: "external",
    get: function get() {
      return this.mirroredNode.external;
    }
  }]);

  return MirroredReferenceNode;
}(BaseNode);

function isStringOrNumber(value) {
  return typeof value === 'string' || typeof value === 'number';
}

function isObject(maybeObj) {
  return maybeObj !== void 0 && maybeObj !== null && typeof maybeObj === 'object';
}

function isPrimitive(maybePrimitive) {
  return typeof maybePrimitive !== 'function' && !isObject(maybePrimitive);
}

function isObjectLiteral(maybeObj) {
  if (isPrimitive(maybeObj) === true) return false;
  var proto = Object.getPrototypeOf(maybeObj);
  return proto === null || proto === Object.prototype;
}

function isNonNullable(maybeNullable) {
  return maybeNullable !== void 0 && maybeNullable !== null;
}

function pick(target, keys) {
  var source = {};

  var _iterator = _createForOfIteratorHelper(keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      if (key in target) {
        source[key] = target[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return source;
}

var MirroredRegularNode = /*#__PURE__*/function (_BaseNode2) {
  _inherits(MirroredRegularNode, _BaseNode2);

  function MirroredRegularNode(mirroredNode, context) {
    var _this2;

    _classCallCheck(this, MirroredRegularNode);

    var _a;

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(MirroredRegularNode).call(this, mirroredNode.fragment));
    _this2.mirroredNode = mirroredNode;
    _this2.originalFragment = (_a = context === null || context === void 0 ? void 0 : context.originalFragment) !== null && _a !== void 0 ? _a : mirroredNode.originalFragment;
    _this2.cache = new WeakMap();
    _this2._this = new Proxy(_assertThisInitialized(_assertThisInitialized(_this2)), {
      get: function get(target, key) {
        if (key in target) {
          return target[key];
        }

        if (key in mirroredNode) {
          return Reflect.get(mirroredNode, key, mirroredNode);
        }

        return;
      },
      has: function has(target, key) {
        return key in target || key in mirroredNode;
      }
    });
    return _possibleConstructorReturn(_this2, _this2._this);
  }

  _createClass(MirroredRegularNode, [{
    key: "children",
    get: function get() {
      var referencedChildren = this.mirroredNode.children;

      if (!isNonNullable(referencedChildren)) {
        return referencedChildren;
      }

      if (this._children === void 0) {
        this._children = [];
      } else {
        this._children.length = 0;
      }

      var children = this._children;

      var _iterator2 = _createForOfIteratorHelper(referencedChildren),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          var cached = this.cache.get(child);

          if (cached !== void 0) {
            children.push(cached);
            continue;
          }

          var mirroredChild = isRegularNode(child) ? new MirroredRegularNode(child) : new MirroredReferenceNode(child);
          mirroredChild.parent = this._this;
          mirroredChild.subpath = child.subpath;
          this.cache.set(child, mirroredChild);
          children.push(mirroredChild);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return children;
    }
  }]);

  return MirroredRegularNode;
}(BaseNode);

function unwrapStringOrNull(value) {
  return typeof value === 'string' ? value : null;
}

function unwrapArrayOrNull(value) {
  return Array.isArray(value) ? value : null;
}

var ReferenceNode = /*#__PURE__*/function (_BaseNode3) {
  _inherits(ReferenceNode, _BaseNode3);

  function ReferenceNode(fragment, error) {
    var _this3;

    _classCallCheck(this, ReferenceNode);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ReferenceNode).call(this, fragment));
    _this3.error = error;
    _this3.value = unwrapStringOrNull(fragment.$ref);
    return _this3;
  }

  _createClass(ReferenceNode, [{
    key: "external",
    get: function get() {
      return this.value !== null && !isLocalRef(this.value);
    }
  }]);

  return ReferenceNode;
}(BaseNode);

var ANNOTATIONS = ['description', 'default', 'examples'];

function getAnnotations(fragment) {
  var annotations = pick(fragment, ANNOTATIONS);

  if ('example' in fragment && !Array.isArray(annotations.examples)) {
    annotations.examples = [fragment.example];
  }

  return annotations;
}

var SchemaNodeKind;

(function (SchemaNodeKind) {
  SchemaNodeKind["Any"] = "any";
  SchemaNodeKind["String"] = "string";
  SchemaNodeKind["Number"] = "number";
  SchemaNodeKind["Integer"] = "integer";
  SchemaNodeKind["Boolean"] = "boolean";
  SchemaNodeKind["Null"] = "null";
  SchemaNodeKind["Array"] = "array";
  SchemaNodeKind["Object"] = "object";
})(SchemaNodeKind || (SchemaNodeKind = {}));

var SchemaCombinerName;

(function (SchemaCombinerName) {
  SchemaCombinerName["AllOf"] = "allOf";
  SchemaCombinerName["AnyOf"] = "anyOf";
  SchemaCombinerName["OneOf"] = "oneOf";
})(SchemaCombinerName || (SchemaCombinerName = {}));

function getCombiners(fragment) {
  var combiners = null;

  if (SchemaCombinerName.AnyOf in fragment) {
    combiners !== null && combiners !== void 0 ? combiners : combiners = [];
    combiners.push(SchemaCombinerName.AnyOf);
  }

  if (SchemaCombinerName.OneOf in fragment) {
    combiners !== null && combiners !== void 0 ? combiners : combiners = [];
    combiners.push(SchemaCombinerName.OneOf);
  }

  if (SchemaCombinerName.AllOf in fragment) {
    combiners !== null && combiners !== void 0 ? combiners : combiners = [];
    combiners.push(SchemaCombinerName.AllOf);
  }

  return combiners;
}

function getPrimaryType(fragment, types) {
  if (types !== null) {
    if (types.includes(SchemaNodeKind.Object)) {
      return SchemaNodeKind.Object;
    }

    if (types.includes(SchemaNodeKind.Array)) {
      return SchemaNodeKind.Array;
    }

    if (types.length > 0) {
      return types[0];
    }

    return null;
  }

  return null;
}

function getRequired(required) {
  if (!Array.isArray(required)) return null;
  return required.filter(isStringOrNumber).map(String);
}

var VALID_TYPES = Object.values(SchemaNodeKind);

var isValidType = function isValidType(maybeType) {
  return typeof maybeType === 'string' && VALID_TYPES.includes(maybeType);
};

function inferType(fragment) {
  if ('properties' in fragment || 'additionalProperties' in fragment || 'patternProperties' in fragment) {
    return SchemaNodeKind.Object;
  }

  if ('items' in fragment || 'additionalItems' in fragment) {
    return SchemaNodeKind.Array;
  }

  return null;
}

function getTypes(fragment) {
  if ('type' in fragment) {
    if (Array.isArray(fragment.type)) {
      return fragment.type.filter(isValidType);
    } else if (isValidType(fragment.type)) {
      return [fragment.type];
    }
  }

  var inferredType = inferType(fragment);

  if (inferredType !== null) {
    return [inferredType];
  }

  return null;
}

var COMMON_VALIDATION_TYPES = ['readOnly', 'writeOnly', 'style'];
var VALIDATION_TYPES = {
  string: ['minLength', 'maxLength', 'pattern'],
  number: ['multipleOf', 'minimum', 'exclusiveMinimum', 'maximum', 'exclusiveMaximum'],

  get integer() {
    return this.number;
  },

  object: ['additionalProperties', 'minProperties', 'maxProperties'],
  array: ['additionalItems', 'minItems', 'maxItems', 'uniqueItems']
};

function getTypeValidations(types) {
  var extraValidations = null;

  var _iterator3 = _createForOfIteratorHelper(types),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var type = _step3.value;
      var value = VALIDATION_TYPES[type];

      if (value !== void 0) {
        var _extraValidations;

        extraValidations !== null && extraValidations !== void 0 ? extraValidations : extraValidations = [];

        (_extraValidations = extraValidations).push.apply(_extraValidations, _toConsumableArray(value));
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return extraValidations;
}

function getValidations(fragment, types) {
  var extraValidations = types === null ? null : getTypeValidations(types);
  return _objectSpread({}, pick(fragment, COMMON_VALIDATION_TYPES), extraValidations !== null ? pick(fragment, extraValidations) : null);
}

function isDeprecated(fragment) {
  if ('x-deprecated' in fragment) {
    return fragment['x-deprecated'] === true;
  }

  if ('deprecated' in fragment) {
    return fragment.deprecated === true;
  }

  return false;
}

var RegularNode = /*#__PURE__*/function (_BaseNode4) {
  _inherits(RegularNode, _BaseNode4);

  function RegularNode(fragment, context) {
    var _this4;

    _classCallCheck(this, RegularNode);

    var _a;

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(RegularNode).call(this, fragment));
    _this4.fragment = fragment;
    _this4.$id = unwrapStringOrNull('id' in fragment ? fragment.id : fragment.$id);
    _this4.types = getTypes(fragment);
    _this4.primaryType = getPrimaryType(fragment, _this4.types);
    _this4.combiners = getCombiners(fragment);
    _this4.deprecated = isDeprecated(fragment);
    _this4.enum = 'const' in fragment ? [fragment.const] : unwrapArrayOrNull(fragment.enum);
    _this4.required = getRequired(fragment.required);
    _this4.format = unwrapStringOrNull(fragment.format);
    _this4.title = unwrapStringOrNull(fragment.title);
    _this4.annotations = getAnnotations(fragment);
    _this4.validations = getValidations(fragment, _this4.types);
    _this4.originalFragment = (_a = context === null || context === void 0 ? void 0 : context.originalFragment) !== null && _a !== void 0 ? _a : fragment;
    _this4.children = void 0;
    return _this4;
  }

  _createClass(RegularNode, [{
    key: "simple",
    get: function get() {
      return this.primaryType !== SchemaNodeKind.Array && this.primaryType !== SchemaNodeKind.Object && this.combiners === null;
    }
  }, {
    key: "unknown",
    get: function get() {
      return this.types === null && this.combiners === null && this.format === null && this.enum === null && Object.keys(this.annotations).length + Object.keys(this.validations).length === 0;
    }
  }]);

  return RegularNode;
}(BaseNode);

var RootNode = /*#__PURE__*/function (_BaseNode5) {
  _inherits(RootNode, _BaseNode5);

  function RootNode(fragment) {
    var _this5;

    _classCallCheck(this, RootNode);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(RootNode).call(this, fragment));
    _this5.fragment = fragment;
    _this5.parent = null;
    _this5.children = [];
    return _this5;
  }

  return RootNode;
}(BaseNode);

function isSchemaNode(node) {
  var name = Object.getPrototypeOf(node).constructor.name;
  return name === RootNode.name || name === RegularNode.name || name === MirroredRegularNode.name || name === ReferenceNode.name || name === MirroredReferenceNode.name;
}

function isRootNode(node) {
  return Object.getPrototypeOf(node).constructor.name === 'RootNode';
}

function isRegularNode(node) {
  return 'types' in node && 'primaryType' in node && 'combiners' in node;
}

function isMirroredNode(node) {
  return 'mirroredNode' in node;
}

function isReferenceNode(node) {
  return 'external' in node && 'value' in node;
}

var ResolvingError = /*#__PURE__*/function (_ReferenceError) {
  _inherits(ResolvingError, _ReferenceError);

  function ResolvingError() {
    var _this6;

    _classCallCheck(this, ResolvingError);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(ResolvingError).apply(this, arguments));
    _this6.name = 'ResolvingError';
    return _this6;
  }

  return ResolvingError;
}(_wrapNativeSuper(ReferenceError));

var MergingError = /*#__PURE__*/function (_Error) {
  _inherits(MergingError, _Error);

  function MergingError() {
    var _this7;

    _classCallCheck(this, MergingError);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(MergingError).apply(this, arguments));
    _this7.name = 'MergingError';
    return _this7;
  }

  return MergingError;
}(_wrapNativeSuper(Error));

var resolveAllOf = require('@stoplight/json-schema-merge-allof');

var store = new WeakMap();

function _mergeAllOf(fragment, path, resolveRef) {
  return resolveAllOf(fragment, _objectSpread({
    deep: false,
    resolvers: resolveAllOf.stoplightResolvers
  }, resolveRef !== null ? {
    $refResolver: function $refResolver($ref) {
      if (typeof $ref !== 'string') {
        return {};
      }

      if (pathToPointer(path).startsWith($ref)) {
        throw new ResolvingError('Circular reference detected');
      }

      var allRefs = store.get(resolveRef);
      var schemaRefs = allRefs.get(fragment);

      if (schemaRefs === void 0) {
        schemaRefs = [$ref];
        allRefs.set(fragment, schemaRefs);
      } else if (schemaRefs.includes($ref)) {
        var safelyResolved = JSON.parse(stringify(resolveRef(null, $ref)));
        return 'allOf' in safelyResolved ? _mergeAllOf(safelyResolved, path, resolveRef) : safelyResolved;
      } else {
        schemaRefs.push($ref);
      }

      var resolved = resolveRef(null, $ref);

      if (Array.isArray(resolved.allOf)) {
        var _iterator4 = _createForOfIteratorHelper(resolved.allOf),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var member = _step4.value;
            var index = schemaRefs.indexOf(member.$ref);

            if (typeof member.$ref === 'string' && index !== -1 && index !== schemaRefs.lastIndexOf(member.$ref)) {
              throw new ResolvingError('Circular reference detected');
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return resolved;
    }
  } : null));
}

function mergeAllOf(fragment, path, walkingOptions) {
  if (walkingOptions.resolveRef !== null && !store.has(walkingOptions.resolveRef)) {
    store.set(walkingOptions.resolveRef, new WeakMap());
  }

  var merged = _mergeAllOf(fragment, path, walkingOptions.resolveRef);

  while ('allOf' in merged) {
    merged = _mergeAllOf(merged, path, walkingOptions.resolveRef);
  }

  return merged;
}

function mergeOneOrAnyOf(fragment, path, walkingOptions) {
  var combiner = SchemaCombinerName.OneOf in fragment ? SchemaCombinerName.OneOf : SchemaCombinerName.AnyOf;
  var items = fragment[combiner];
  if (!Array.isArray(items)) return [];
  var merged = [];

  if (Array.isArray(fragment.allOf) && Array.isArray(items)) {
    var _iterator5 = _createForOfIteratorHelper(items),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var item = _step5.value;
        merged.push({
          allOf: [].concat(_toConsumableArray(fragment.allOf), [item])
        });
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }

    return merged;
  } else {
    var _iterator6 = _createForOfIteratorHelper(items),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var _item = _step6.value;

        var prunedSchema = _objectSpread({}, fragment);

        delete prunedSchema[combiner];

        if (Object.keys(prunedSchema).length === 0) {
          merged.push(_item);
        } else {
          var resolvedItem = typeof _item.$ref === 'string' && walkingOptions.resolveRef !== null ? walkingOptions.resolveRef(null, _item.$ref) : _item;
          var mergedSchema = {
            allOf: [prunedSchema, resolvedItem]
          };

          try {
            merged.push(mergeAllOf(mergedSchema, path, walkingOptions));
          } catch (_a) {
            merged.push(mergedSchema);
          }
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }

  return merged;
}

var Walker = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Walker, _EventEmitter);

  function Walker(root, walkingOptions) {
    var _this8;

    _classCallCheck(this, Walker);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(Walker).call(this));
    _this8.root = root;
    _this8.walkingOptions = walkingOptions;
    _this8.path = [];
    _this8.depth = -1;
    _this8.fragment = root.fragment;
    _this8.schemaNode = root;
    _this8.processedFragments = new WeakMap();
    _this8.hooks = {};
    return _this8;
  }

  _createClass(Walker, [{
    key: "destroy",
    value: function destroy() {
      this.path.length = 0;
      this.depth = -1;
      this.fragment = this.root.fragment;
      this.schemaNode = this.root;
      this.processedFragments = new WeakMap();
    }
  }, {
    key: "loadSnapshot",
    value: function loadSnapshot(snapshot) {
      var _this$path;

      (_this$path = this.path).splice.apply(_this$path, [0, this.path.length].concat(_toConsumableArray(snapshot.path)));

      this.depth = snapshot.depth;
      this.fragment = snapshot.fragment;
      this.schemaNode = snapshot.schemaNode;
    }
  }, {
    key: "saveSnapshot",
    value: function saveSnapshot() {
      return {
        depth: this.depth,
        fragment: this.fragment,
        schemaNode: this.schemaNode,
        path: this.path.slice()
      };
    }
  }, {
    key: "hookInto",
    value: function hookInto(action, handler) {
      this.hooks[action] = handler;
    }
  }, {
    key: "restoreWalkerAtNode",
    value: function restoreWalkerAtNode(node) {
      var _this$path2;

      this.processedFragments.delete(node.fragment);

      (_this$path2 = this.path).splice.apply(_this$path2, [0, this.path.length].concat(_toConsumableArray(node.path)));

      this.depth = node.depth;
      this.fragment = node.fragment;
      this.schemaNode = node;
    }
  }, {
    key: "walk",
    value: function walk() {
      var _a, _b, _c, _d;

      var initialDepth = this.depth,
          fragment = this.fragment;
      var initialSchemaNode = this.schemaNode;

      if (initialDepth === -1 && Object.keys(fragment).length === 0) {
        return;
      }

      while (isMirroredNode(initialSchemaNode)) {
        if (!isRegularNode(initialSchemaNode.mirroredNode)) {
          return;
        }

        if (initialSchemaNode.mirroredNode.children === void 0) {
          this.restoreWalkerAtNode(initialSchemaNode.mirroredNode);
          initialSchemaNode = this.schemaNode;
          this.depth = initialDepth;
        } else {
          return;
        }
      }

      var state = this.dumpInternalWalkerState();

      _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'enterFragment', fragment);

      var _this$processFragment = this.processFragment(),
          _this$processFragment2 = _slicedToArray(_this$processFragment, 2),
          schemaNode = _this$processFragment2[0],
          initialFragment = _this$processFragment2[1];

      _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'enterNode', schemaNode);

      var actualNode = isMirroredNode(schemaNode) ? schemaNode.mirroredNode : schemaNode;
      this.processedFragments.set(schemaNode.fragment, actualNode);
      this.processedFragments.set(initialFragment, actualNode);
      this.fragment = schemaNode.fragment;
      this.depth = initialDepth + 1;
      var isIncluded = (_b = (_a = this.hooks).filter) === null || _b === void 0 ? void 0 : _b.call(_a, schemaNode);

      if (isIncluded === false) {
        _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'skipNode', schemaNode);

        return;
      }

      if (!isRootNode(schemaNode)) {
        schemaNode.parent = initialSchemaNode;
        schemaNode.subpath = this.path.slice(initialSchemaNode.path.length);
      }

      if ('children' in initialSchemaNode && !isRootNode(schemaNode)) {
        if (initialSchemaNode.children === void 0) {
          initialSchemaNode.children = [schemaNode];
        } else {
          initialSchemaNode.children.push(schemaNode);
        }
      }

      _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'includeNode', schemaNode);

      if (isRegularNode(schemaNode)) {
        this.schemaNode = schemaNode;

        if (((_d = (_c = this.hooks).stepIn) === null || _d === void 0 ? void 0 : _d.call(_c, schemaNode)) !== false) {
          _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'stepInNode', schemaNode);

          this.walkNodeChildren();

          _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'stepOutNode', schemaNode);
        } else {
          _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'stepOverNode', schemaNode);
        }
      }

      _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'exitNode', schemaNode);

      this.restoreInternalWalkerState(state);

      _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'exitFragment', fragment);
    }
  }, {
    key: "dumpInternalWalkerState",
    value: function dumpInternalWalkerState() {
      return {
        depth: this.depth,
        pathLength: this.path.length,
        schemaNode: this.schemaNode
      };
    }
  }, {
    key: "restoreInternalWalkerState",
    value: function restoreInternalWalkerState(_ref) {
      var depth = _ref.depth,
          pathLength = _ref.pathLength,
          schemaNode = _ref.schemaNode;
      this.depth = depth;
      this.path.length = pathLength;
      this.schemaNode = schemaNode;
    }
  }, {
    key: "walkNodeChildren",
    value: function walkNodeChildren() {
      var fragment = this.fragment,
          schemaNode = this.schemaNode;
      if (!isRegularNode(schemaNode)) return;
      var state = this.dumpInternalWalkerState();

      if (schemaNode.combiners !== null) {
        var _iterator7 = _createForOfIteratorHelper(schemaNode.combiners),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var combiner = _step7.value;
            var items = fragment[combiner];
            if (!Array.isArray(items)) continue;
            var i = -1;

            var _iterator8 = _createForOfIteratorHelper(items),
                _step8;

            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var item = _step8.value;
                i++;
                if (!isObjectLiteral(item)) continue;
                this.fragment = item;
                this.restoreInternalWalkerState(state);
                this.path.push(combiner, String(i));
                this.walk();
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      }

      switch (schemaNode.primaryType) {
        case SchemaNodeKind.Array:
          if (Array.isArray(fragment.items)) {
            var _i = -1;

            var _iterator9 = _createForOfIteratorHelper(fragment.items),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _item2 = _step9.value;
                _i++;
                if (!isObjectLiteral(_item2)) continue;
                this.fragment = _item2;
                this.restoreInternalWalkerState(state);
                this.path.push('items', String(_i));
                this.walk();
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          } else if (isObjectLiteral(fragment.items)) {
            this.fragment = fragment.items;
            this.restoreInternalWalkerState(state);
            this.path.push('items');
            this.walk();
          }

          break;

        case SchemaNodeKind.Object:
          if (isObjectLiteral(fragment.properties)) {
            for (var _i2 = 0, _Object$keys = Object.keys(fragment.properties); _i2 < _Object$keys.length; _i2++) {
              var key = _Object$keys[_i2];
              var value = fragment.properties[key];
              if (!isObjectLiteral(value)) continue;
              this.fragment = value;
              this.restoreInternalWalkerState(state);
              this.path.push('properties', key);
              this.walk();
            }
          }

          if (isObjectLiteral(fragment.patternProperties)) {
            for (var _i3 = 0, _Object$keys2 = Object.keys(fragment.patternProperties); _i3 < _Object$keys2.length; _i3++) {
              var _key = _Object$keys2[_i3];
              var _value = fragment.patternProperties[_key];
              if (!isObjectLiteral(_value)) continue;
              this.fragment = _value;
              this.restoreInternalWalkerState(state);
              this.path.push('patternProperties', _key);
              this.walk();
            }
          }

          break;
      }

      this.schemaNode = schemaNode;
    }
  }, {
    key: "retrieveFromFragment",
    value: function retrieveFromFragment(fragment, originalFragment) {
      var processedSchemaNode = this.processedFragments.get(fragment);

      if (processedSchemaNode !== void 0) {
        if (isRegularNode(processedSchemaNode)) {
          return [new MirroredRegularNode(processedSchemaNode, {
            originalFragment: originalFragment
          }), fragment];
        }

        if (isReferenceNode(processedSchemaNode)) {
          return [new MirroredReferenceNode(processedSchemaNode), fragment];
        }

        throw new TypeError('Cannot mirror the node');
      }
    }
  }, {
    key: "processFragment",
    value: function processFragment() {
      var _a, _b, _c;

      var walkingOptions = this.walkingOptions,
          path = this.path,
          originalFragment = this.fragment;
      var fragment = this.fragment;
      var retrieved = isNonNullable(fragment) ? this.retrieveFromFragment(fragment, originalFragment) : null;

      if (retrieved) {
        return retrieved;
      }

      if ('$ref' in fragment) {
        if (typeof fragment.$ref !== 'string') {
          return [new ReferenceNode(fragment, '$ref is not a string'), fragment];
        } else if (walkingOptions.resolveRef !== null) {
          try {
            var newFragment = walkingOptions.resolveRef(path, fragment.$ref);

            if (typeof fragment.description === 'string') {
              newFragment = _objectSpread({}, newFragment);
              Object.assign(newFragment, {
                description: fragment.description
              });
            }

            fragment = newFragment;
          } catch (ex) {
            _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'error', createMagicError(ex));

            return [new ReferenceNode(fragment, (_a = ex === null || ex === void 0 ? void 0 : ex.message) !== null && _a !== void 0 ? _a : 'Unknown resolving error'), fragment];
          }
        } else {
          return [new ReferenceNode(fragment, null), fragment];
        }
      }

      var initialFragment = fragment;

      if (walkingOptions.mergeAllOf && SchemaCombinerName.AllOf in fragment) {
        try {
          if (Array.isArray(fragment.allOf)) {
            initialFragment = fragment.allOf;
          }

          fragment = mergeAllOf(fragment, path, walkingOptions);
        } catch (ex) {
          initialFragment = fragment;

          _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'error', createMagicError(new MergingError((_b = ex === null || ex === void 0 ? void 0 : ex.message) !== null && _b !== void 0 ? _b : 'Unknown merging error')));
        }
      }

      if (SchemaCombinerName.OneOf in fragment || SchemaCombinerName.AnyOf in fragment) {
        try {
          var merged = mergeOneOrAnyOf(fragment, path, walkingOptions);

          if (merged.length === 1) {
            return [new RegularNode(merged[0], {
              originalFragment: originalFragment
            }), initialFragment];
          } else {
            var combiner = SchemaCombinerName.OneOf in fragment ? SchemaCombinerName.OneOf : SchemaCombinerName.AnyOf;
            return [new RegularNode(_defineProperty({}, combiner, merged), {
              originalFragment: originalFragment
            }), initialFragment];
          }
        } catch (ex) {
          _get(_getPrototypeOf(Walker.prototype), "emit", this).call(this, 'error', createMagicError(new MergingError((_c = ex === null || ex === void 0 ? void 0 : ex.message) !== null && _c !== void 0 ? _c : 'Unknown merging error')));
        }
      }

      retrieved = isNonNullable(fragment) ? this.retrieveFromFragment(initialFragment, originalFragment) : null;

      if (retrieved) {
        return retrieved;
      }

      return [new RegularNode(fragment, {
        originalFragment: originalFragment
      }), initialFragment];
    }
  }]);

  return Walker;
}(EventEmitter);

var SchemaTree = /*#__PURE__*/function () {
  function SchemaTree(schema, opts) {
    var _this9 = this;

    _classCallCheck(this, SchemaTree);

    var _a;

    this.schema = schema;
    this.opts = opts;

    this.resolveRef = function (path, $ref) {
      var seenRefs = [];
      var cur$ref = $ref;
      var resolvedValue;

      while (typeof cur$ref === 'string') {
        if (seenRefs.includes(cur$ref)) {
          break;
        }

        seenRefs.push(cur$ref);
        resolvedValue = _this9._resolveRef(path, cur$ref);
        cur$ref = resolvedValue.$ref;
      }

      return resolvedValue;
    };

    this._resolveRef = function (path, $ref) {
      var _a;

      var source = extractSourceFromRef($ref);
      var pointer = extractPointerFromRef($ref);
      var refResolver = (_a = _this9.opts) === null || _a === void 0 ? void 0 : _a.refResolver;

      if (typeof refResolver === 'function') {
        return refResolver({
          source: source,
          pointer: pointer
        }, path, _this9.schema);
      } else if (source !== null) {
        throw new ResolvingError('Cannot dereference external references');
      } else if (pointer === null) {
        throw new ResolvingError('The pointer is empty');
      } else if (isObjectLiteral(_this9.schema)) {
        var value = resolveInlineRef(_this9.schema, pointer);

        if (!isObjectLiteral(value)) {
          throw new ResolvingError('Invalid value');
        }

        return value;
      } else {
        throw new ResolvingError('Unexpected input');
      }
    };

    this.root = new RootNode(schema);
    this.walker = new Walker(this.root, {
      mergeAllOf: ((_a = this.opts) === null || _a === void 0 ? void 0 : _a.mergeAllOf) !== false,
      resolveRef: (opts === null || opts === void 0 ? void 0 : opts.refResolver) === null ? null : this.resolveRef
    });
  }

  _createClass(SchemaTree, [{
    key: "destroy",
    value: function destroy() {
      this.root.children.length = 0;
      this.walker.destroy();
    }
  }, {
    key: "populate",
    value: function populate() {
      this.invokeWalker(this.walker);
    }
  }, {
    key: "invokeWalker",
    value: function invokeWalker(walker) {
      walker.walk();
    }
  }]);

  return SchemaTree;
}();

export { BaseNode, MirroredReferenceNode, MirroredRegularNode, ReferenceNode, RegularNode, RootNode, SchemaCombinerName, SchemaNodeKind, SchemaTree, isMirroredNode, isReferenceNode, isRegularNode, isRootNode, isSchemaNode };